module.exports = "https://coursera_assets.s3.amazonaws.com/images/39627d4bf717a416965a8b90532b49b3.png";